import { graphql } from '@app/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query storefront_isEachOnlineOrderServiceAvailable($branchId: ID!) {
    storefront_isEachOnlineOrderServiceAvailable(branchId: $branchId) {
      deliveryAvailable
      pickupAvailable
    }
  }
`);

export default function useOnlineOrderServiceAvailable(branchId: string) {
  return useQuery(QUERY, {
    variables: {
      branchId,
    },
  });
}
